interface GithubTestingOption {
  value: string
  label: string
  description: string
  comingSoon?: boolean
  hasUrl?: boolean
}

// Main-branch and pull-request testing choices for the onboarding GitHub questions.

export const MAIN_BRANCH_TEST_OPTIONS: GithubTestingOption[] = [
  { value: 'none', label: 'None', description: "Don't run QA against the main branch." },
  { value: 'detect', label: 'Detect main branch deployments', description: 'Run QA when a new deployment of the main branch goes live.', hasUrl: true },
  { value: 'events', label: 'Listen to GitHub events', description: 'Run QA when GitHub reports a main-branch deployment (e.g. Vercel, Netlify).' },
  { value: 'environment', label: 'Set up dedicated test environment', description: 'Spin up an isolated environment to test each change.', comingSoon: true },
]

export const PR_TEST_OPTIONS: GithubTestingOption[] = [
  { value: 'none', label: 'None', description: "Don't run QA on pull requests." },
  { value: 'events', label: 'Listen to GitHub events', description: 'Run QA when GitHub reports a pull-request preview deployment (e.g. Vercel, Netlify), and post the results back as a comment.' },
  { value: 'environment', label: 'Set up dedicated test environment', description: 'Spin up an isolated environment to test each PR.', comingSoon: true },
]
